import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import '../../styles.less';
import { Grid } from 'semantic-ui-react';
import { ErrorComponent } from '../../../../../../../components/error-component';
import { HourIcon, KmIcon, PriceIcon } from '../../../../../../../components/text-icon';
import { normalizeNumber } from '../../../../../../../utils/normalizeNumber';
import { FormInputField } from '../../../../../../../semantic-ui/components/form-input-field';
import { normalizeInteger } from '../../../../../../../utils/normalizeInteger';

export const TariffTypeField = ({ tariffTypes }) => {
	return (
		<>
			{tariffTypes.map((row, index) => {
				return (
					<React.Fragment key={row.id}>
						<Grid>
							<Grid.Row className="autopark-transport-form__row autopark-transport-form__row-title">
								<Grid.Column width={16}>
									<h3 className="autopark-transport-form__second-title">{row.name}</h3>
								</Grid.Column>
							</Grid.Row>

							<Grid.Row className="autopark-transport-form__row">
								<Grid.Column width={6} className="autopark-transport-form__column">
									Стоимость выхода транспорта на рейс
								</Grid.Column>
								<Grid.Column width={7} className="autopark-transport-form__column">
									<Field
										key={`transport_cost_per_shift_${row.id}`}
										name={`tariffs[${index}]transport_cost_per_shift`}
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										placeholder="Укажите стоимость выхода транспорта на рейс"
										icon={PriceIcon}
									/>
								</Grid.Column>
							</Grid.Row>

							<Grid.Row className="autopark-transport-form__row">
								<Grid.Column width={6} className="autopark-transport-form__column">
									Стоимость выхода водителя на рейс
								</Grid.Column>
								<Grid.Column width={7} className="autopark-transport-form__column">
									<Field
										key={`performer_cost_per_shift_${row.id}`}
										name={`tariffs[${index}]performer_cost_per_shift`}
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										placeholder="Укажите стоимость выхода водителя на рейс"
										icon={PriceIcon}
									/>
								</Grid.Column>
							</Grid.Row>

							<Grid.Row className="autopark-transport-form__row">
								<Grid.Column width={6} className="autopark-transport-form__column">
									Цена за час пути
								</Grid.Column>

								<Grid.Column
									width={7}
									className="autopark-transport-form__column autopark-transport-form__price-fields"
								>
									<Grid className="autopark-transport-form__wrapper">
										<Grid.Row className="autopark-transport-form__price-row">
											<Grid.Column className="autopark-transport-form__price-col">
												<Field
													key={`performer_cost_per_unit_${row.id}`}
													name={`tariffs[${index}]performer_cost_per_unit`}
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													icon={PriceIcon}
													placeholder="цена за 1 час"
													isWithoutErrorText
												/>
											</Grid.Column>
											<Grid.Column className="autopark-transport-form__separator">-</Grid.Column>
											<Grid.Column className="autopark-transport-form__price-col">
												<Field
													key={`performer_stage_length_${row.id}`}
													name={`tariffs[${index}]performer_stage_length`}
													type="text"
													normalize={normalizeInteger}
													component={FormInputField}
													autoComplete="off"
													icon={HourIcon}
													placeholder="кол-во часов"
													isWithoutErrorText
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="autopark-transport-form__row autopark-transport-form__row autopark-transport-form__row-error">
											<Grid.Column
												className="autopark-transport-form__column-tariff-type-error"
												width={16}
											>
												<Field
													name={`tariffs[${index}]performer_cost_per_unit`}
													component={ErrorComponent}
												/>
											</Grid.Column>
											<Grid.Column
												className="autopark-transport-form__column-tariff-type-error"
												width={16}
											>
												<Field
													name={`tariffs[${index}]performer_stage_length`}
													component={ErrorComponent}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Grid.Column>
							</Grid.Row>

							<Grid.Row className="autopark-transport-form__row">
								<Grid.Column width={6} className="autopark-transport-form__column">
									Стоимость сверх базового часа
								</Grid.Column>
								<Grid.Column width={7} className="autopark-transport-form__column">
									<Field
										key={`performer_cost_per_unit_sub_${row.id}`}
										name={`tariffs[${index}]performer_cost_per_unit_sub`}
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										placeholder="Укажите стоимость сверх базового часа"
										icon={PriceIcon}
									/>
								</Grid.Column>
							</Grid.Row>

							<Grid.Row className="autopark-transport-form__row">
								<Grid.Column width={6} className="autopark-transport-form__column">
									Цена за км пути
								</Grid.Column>

								<Grid.Column
									width={7}
									className="autopark-transport-form__column autopark-transport-form__price-fields"
								>
									<Grid className="autopark-transport-form__wrapper">
										<Grid.Row className="autopark-transport-form__price-row">
											<Grid.Column className="autopark-transport-form__price-col">
												<Field
													key={`transport_cost_per_unit_${row.id}`}
													name={`tariffs[${index}]transport_cost_per_unit`}
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													icon={PriceIcon}
													placeholder="цена за 1 км"
													isWithoutErrorText
												/>
											</Grid.Column>
											<Grid.Column className="autopark-transport-form__separator">-</Grid.Column>
											<Grid.Column className="autopark-transport-form__price-col">
												<Field
													key={`transport_stage_length_${row.id}`}
													name={`tariffs[${index}]transport_stage_length`}
													type="text"
													normalize={normalizeInteger}
													component={FormInputField}
													autoComplete="off"
													icon={KmIcon}
													placeholder="кол-во км"
													isWithoutErrorText
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="autopark-transport-form__row autopark-transport-form__row autopark-transport-form__row-error">
											<Grid.Column
												className="autopark-transport-form__column-tariff-type-error"
												width={16}
											>
												<Field
													name={`tariffs[${index}]transport_cost_per_unit`}
													component={ErrorComponent}
												/>
											</Grid.Column>
											<Grid.Column
												className="autopark-transport-form__column-tariff-type-error"
												width={16}
											>
												<Field
													name={`tariffs[${index}]transport_stage_length`}
													component={ErrorComponent}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Grid.Column>
							</Grid.Row>

							<Grid.Row className="autopark-transport-form__row">
								<Grid.Column width={6} className="autopark-transport-form__column">
									Стоимость 1 км пробега свыше базового
								</Grid.Column>
								<Grid.Column width={7} className="autopark-transport-form__column">
									<Field
										key={`performer_cost_per_unit_sub_${row.id}`}
										name={`tariffs[${index}]transport_cost_per_unit_sub`}
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										placeholder="Укажите стоимость 1 км пробега свыше базового"
										icon={PriceIcon}
									/>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</React.Fragment>
				);
			})}
		</>
	);
};

TariffTypeField.propTypes = {
	tariffTypes: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired,
		}),
	).isRequired,
};
